import axios from "axios";

import axiosInstance from "../app/axios";

const apiKey = process.env.REACT_APP_GOOGLE_MAP_KEY;

export const validateAddress = async (address: string) => {
  const response = await axios.get(
    `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
      address,
    )}&key=${apiKey}`,
  );

  let results = response?.data?.results;

  if (results?.length === 1) {
    const components = results[0].address_components;
    const countryComponent = components.find((comp: any) =>
      comp.types.includes("country"),
    );

    if (countryComponent?.short_name === "UY") {
      return results[0];
    }
  }

  const fallbackResponse = await axiosInstance.get(
    `google/places?address=${encodeURIComponent(`${address}, Uruguay`)}`,
  );

  results = fallbackResponse?.data?.results;

  if (results?.length === 1) {
    const addressIncludesUruguay =
      results[0].formatted_address.includes("Uruguay");

    if (addressIncludesUruguay) {
      return results[0];
    }
  }

  return null;
};

export const snapToRoads = async (points: { latitude: number; longitude: number }[]) => {
  if (!points || points.length < 2) return points;

  const CHUNK_SIZE = 100;
  const chunks = [];
  for (let i = 0; i < points.length; i += CHUNK_SIZE) {
    chunks.push(points.slice(i, i + CHUNK_SIZE));
  }

  try {
    const allSnappedPoints = [];
    for (const chunk of chunks) {
      const pathParam = chunk.map(p => `${p.latitude},${p.longitude}`).join('|');
      const response = await axios.get(
        `https://roads.googleapis.com/v1/snapToRoads?path=${pathParam}&interpolate=true&key=${apiKey}`
      );
      
      if (response.data?.snappedPoints) {
        allSnappedPoints.push(...response.data.snappedPoints.map((sp: any) => ({
          latitude: sp.location.latitude,
          longitude: sp.location.longitude,
        })));
      }
    }
    return allSnappedPoints.length > 0 ? allSnappedPoints : points;
  } catch (error) {
    console.error("Error snapping to roads:", error);
    return points;
  }
};
